<template>
  <div v-if="!loading">
    <div class="col-12">
      <div class="row" style="margin-top: 15px;">
        <div class="col-3 text-center" style="padding: 8px;">
          <div class="card">
            <label class="title">Email</label>

            <div class="col-12">
              <div class="row text-center">
                <div class="col-12">
                  <font-awesome-icon
                    style="color: #4de594; font-size: 20px;"
                    :icon="['fa', 'envelope']"
                  />
                  <span class="number">{{ this.email }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-3 text-center" style="padding: 8px;">
          <div class="card">
            <label class="title">App</label>

            <div class="col-12">
              <div class="row text-center">
                <div class="col-12">
                  <font-awesome-icon
                    style="color: #4de594; font-size: 20px;"
                    :icon="['fa', 'mobile-alt']"
                  />
                  <span class="number">{{ this.app }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-3 text-center" style="padding: 8px;">
          <div class="card">
            <label class="title">Link</label>

            <div class="col-12">
              <div class="row text-center">
                <div class="col-12">
                  <font-awesome-icon
                    style="color: #4de594; font-size: 20px;"
                    :icon="['fa', 'paperclip']"
                  />
                  <span class="number">{{ this.link }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-3 text-center" style="padding: 8px;">
          <div class="card">
            <label class="title">Sms</label>

            <div class="col-12">
              <div class="row text-center">
                <div class="col-12">
                  <font-awesome-icon
                    style="color: #4de594; font-size: 20px;"
                    :icon="['fa', 'sms']"
                  />
                  <span class="number">{{ this.sms }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="row">
        <div class="col-3 text-center" style="padding: 8px;">
          <div class="card">
            <label class="title">Manual</label>

            <div class="col-12">
              <div class="row text-center">
                <div class="col-12">
                  <font-awesome-icon
                    style="color: #4de594; font-size: 20px;"
                    :icon="['fa', 'user']"
                  />
                  <span class="number">{{ this.manual }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-3 text-center" style="padding: 8px;">
          <div class="card">
            <label class="title">QrCode</label>

            <div class="col-12">
              <div class="row text-center">
                <div class="col-12">
                  <font-awesome-icon
                    style="color: #4de594; font-size: 20px;"
                    :icon="['fa', 'qrcode']"
                  />
                  <span class="number">{{ this.qrcode }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-3 text-center" style="padding: 8px;">
          <div class="card">
            <label class="title">Widget</label>

            <div class="col-12">
              <div class="row text-center">
                <div class="col-12">
                  <font-awesome-icon
                    style="color: #4de594; font-size: 20px;"
                    :icon="['fa', 'th-large']"
                  />
                  <span class="number">{{ this.widget }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-3 text-center" style="padding: 8px;">
          <div class="card">
            <label class="title">Whatsapp</label>

            <div class="col-12">
              <div class="row text-center">
                <div class="col-12">
                  <i
                    style="color: #4de594; font-size: 20px;"
                    class="fab fa-whatsapp"
                  ></i>
                  <span class="number">{{ this.whatsapp }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="row mt-4">
      <div class="col-3">
        <idx-skeleton height="100" radius="8" />
      </div>
      <div class="col-3">
        <idx-skeleton height="100" radius="8" />
      </div>
      <div class="col-3">
        <idx-skeleton height="100" radius="8" />
      </div>
      <div class="col-3">
        <idx-skeleton height="100" radius="8" />
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-3">
        <idx-skeleton height="100" radius="8" />
      </div>
      <div class="col-3">
        <idx-skeleton height="100" radius="8" />
      </div>
      <div class="col-3">
        <idx-skeleton height="100" radius="8" />
      </div>
      <div class="col-3">
        <idx-skeleton height="100" radius="8" />
      </div>
    </div>
  </div>
</template>

<script>
import idxSkeleton from '@/components/molecules/idx-skeleton';
import api from '../../../../../../services/api';

export default {
  data: () => ({
    userAuth: null,
    email: 0,
    app: 0,
    link: 0,
    sms: 0,
    manual: 0,
    qrcode: 0,
    widget: 0,
    whatsapp: 0,
    loading: false,
  }),

  props: ['dataGraph'],

  components: {
    idxSkeleton,
  },

  methods: {
    async getData() {
      this.loading = true;

      const response = await api.get('/reports/panel/answers-by-channel-panel', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.dataGraph.actionId
          ? this.dataGraph.actionId._id
          : null,
          // startDate: '2022-01-15',
          // endDate: '2022-07-15',
          period: this.dataGraph.period,
          ih1: this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
          groupId: this.dataGraph.actionGroupId
          ? this.dataGraph.actionGroupId._id
          : null,
          metric: this.dataGraph.metric,
          indicator: this.dataGraph.indicator ? this.dataGraph.indicator : null,
          indicatorValue: this.dataGraph.valueIndicator,
          _id: this.dataGraph._id,
        },
      });

      this.email = response.data.email.total;
      this.app = response.data.app.total;
      this.link = response.data.link.total;
      this.sms = response.data.sms.total;
      this.manual = response.data.manual.total;
      this.qrcode = response.data.qrcode.total;
      this.widget = response.data.widget.total;
      this.whatsapp = response.data.whatsapp.total;

      this.loading = false;
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.getData();
  },
};
</script>

<style scoped>
.card {
  box-shadow: 0px 2px 6px rgba(41, 70, 97, 0.2);
  border-radius: 4px;
  min-height: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title {
  font-weight: 400;
  font-size: 18px;
  line-height: 20px;
}

.number {
  font-weight: 500;
  font-size: 24px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/answers-by-channel/panels/index.vue